export default __webpack_public_path__ + "static/1-ae11f8475211f359a112f50dbab1178b.png";